import { Platform } from 'react-native';

const CHINA_HOST_PATTERNS = [
  /\.cn$/i,
  /smartsaas\.cn/i,
  /china\.smartsaas/i,
];

/**
 * True when the app is served from a China deployment (replaces Google with WeChat/Alipay login).
 * Explicit override: EXPO_PUBLIC_CHINA_FRONTEND=true|false
 */
export function isChinaFrontend(): boolean {
  const envFlag = process.env.EXPO_PUBLIC_CHINA_FRONTEND;
  if (envFlag === '1' || envFlag === 'true') return true;
  if (envFlag === '0' || envFlag === 'false') return false;

  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (CHINA_HOST_PATTERNS.some((pattern) => pattern.test(host))) {
      return true;
    }
  }

  return false;
}
